import { Link } from 'react-router-dom'
import { routes } from '../../router'

const PUBLIC_URL = process.env.PUBLIC_URL

function Logo ({ className, flipped }) {
  const name = flipped ? 'ui-global-logo-combo-ondark-small-flip' : 'ui-global-logo-combo-ondark-small'
  const sm = `${PUBLIC_URL}/${name}.png`
  const md = `${PUBLIC_URL}/${name}@2x.png`
  const lg = `${PUBLIC_URL}/${name}@3x.png`
  return (
    <Link
      to={routes.dashboard()}
    >
      <img
        className={className}
        alt='Logo'
        src={sm}
        srcSet={`${sm} 1x, ${md} 2x, ${lg} 3x`}
      />
    </Link>
  )
}

export default Logo
